import styled, {ThemeProps} from 'styled-components';

import {Theme} from './../../../../theme/types';
import {Column, Row} from './../../common/Layouts/Layouts';

export const WrapperDiv = styled(Column)(
  (props: ThemeProps<Theme>) => `
  border: 0.1rem solid ${props.theme.colors.goBrandBlue.light};
  border-radius: ${props.theme.misc.borderRadius.xlarge};
  background: white;
`,
);

export const ContentWrapperDiv = styled(Column)(
  (props: ThemeProps<Theme>) => `
  border-bottom: 0.1rem solid ${props.theme.colors.ash.medium};
`,
);

export const HeadingWrapper = styled(Column)(
  (props: ThemeProps<Theme>) => `
  padding: ${props.theme.spacing.xlarge} ${props.theme.spacing.base} ${props.theme.spacing.xlarge} ${props.theme.spacing.base};
  border-bottom: 0.1rem solid ${props.theme.colors.ash.medium};
  width: 100%;
`,
);

export const HeadingTextStyle = styled.p(
  (props: ThemeProps<Theme>) => `
  font-size: ${props.theme.font.custom(14)};
  font-weight: bold;
`,
);

export const MainContentWrapperDiv = styled(Row)(
  (props: ThemeProps<Theme>) => `
  // padding: ${props.theme.spacing.xlarge} ${props.theme.spacing.base} ${props.theme.spacing.base} ${props.theme.spacing.base};
  align-items: center;
  padding-top: 10px;
`,
);

export const TagWrapperDiv = styled(Column)(
  (props: ThemeProps<Theme>) => `
  margin-right: ${props.theme.spacing.base};
  margin-bottom: ${props.theme.spacing.base};
  padding: ${props.theme.spacing.base};
  border-radius: ${props.theme.misc.borderRadius.base};
  background-color: ${props.theme.colors.ash.medium};
  cursor: pointer;
  &.active{
    background-color: ${props.theme.colors.goBrandBlue.base};
    color: white;
    span{
      color:white;
    }
  }
`,
);

export const TagTextStyle = styled.span(
  (props: ThemeProps<Theme>) => `
  font-size: ${props.theme.font.custom(14)};
  color: ${props.theme.colors.downriver.dark};
  line-height: 1;
  text-transform: capitalize;
`,
);

//new css

export const TripPopWrapperDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  max-width: 74rem;
  margin: 0 auto;
  width:100%;
  background-color:${props.theme.colors.goWhite.base};
  border-radius:${props.theme.misc.borderRadius.large};
  margin-top:${props.theme.spacing.xlarge};

`,
);

export const TripAdvisorContentWrapperDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;

`,
);

export const TripAdvisorHeaderDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row
  border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
  padding:${props.theme.spacing.base};

`,
);

export const HeaderTxtDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  font-size:${props.theme.font.custom(16)};
  font-weight:bold;
  font-family:${props.theme.font.fontFamily};

`,
);

export const TripAdvisorPopMainContentDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row
  padding:${props.theme.spacing.base};
  border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};

`,
);

export const OptionsWrapperDiv = styled.ul(
  props => `
  display: flex;
  flex-wrap:wrap;
  flex-direction: row;
  align-items: center;
  padding:${props.theme.spacing.base};
  li{
    display: flex;
    flex-wrap:wrap;
    flex-direction: column;
    padding:${props.theme.spacing.small};
    border-radius: ${props.theme.misc.borderRadius.base};
    margin-right:${props.theme.spacing.base};
    margin-bottom:${props.theme.spacing.base};
    cursor: pointer;
    &.yellowWrap{
      &.active{
        background-color:${props.theme.colors.goYellow.light};
      }

      border: ${props.theme.misc.border.base} solid ${props.theme.colors.goYellow.dark};
    }
    &.greenWrap{
      &.active{
        background-color:${props.theme.colors.goGreen.light};
      }

      border: ${props.theme.misc.border.base} solid ${props.theme.colors.goGreen.medium};
    }
    &.redWrap{
      &.active{
        background-color:${props.theme.colors.goRed.light};
      }

      border: ${props.theme.misc.border.base} solid ${props.theme.colors.goRed.base};
    }

  }
  `,
);

export const OptionsKindWrapSpan = styled.span(
  props => `
  font-size:${props.theme.font.custom(14)};
      color:${props.theme.colors.downriver.dark};

`,
);

export const LastContentDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row
  padding:${props.theme.spacing.base};
  justify-content: flex-end;

`,
);

export const ShowReviewSpan = styled.span(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row
  padding:${props.theme.spacing.small};
  font-size:${props.theme.font.custom(16)};
  font-weight:bold;


`,
);
